import { useAuthStore } from './useAuthStore'
import type { IsAuthorized } from './IsAuthorized'

export const useAuth = (): { isAuthorized: IsAuthorized } => {
  const authStore = useAuthStore()
  const isAuthorized: IsAuthorized = authStore.isAuthorized
  return { isAuthorized }
}
